<template>
  <transition name="bounce">
    <slot></slot>
  </transition>
</template>

<script>
export default {
  name: 'BounceTransition'
}
</script>

<style scoped lang="scss">
.bounce-enter-active {
  animation: bounce-in 0.3s;
}
.bounce-leave-active {
  animation: bounce-in 0.3s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.6);
  }
  100% {
    transform: scale(1);
  }
}
</style>
